<div class="body">
  @if (isEnabled === false) {
    <div class="disabled-screen">
      <div class="disabled-screen__content">
        <h1 class="disabled-screen__title">De AI assistent is op dit moment niet beschikbaar</h1>
        <p class="disabled-screen__description">
          Dit kan gebeuren omdat we het nog aan het testen zijn. Als je nu hulp nodig hebt, neem dan rechtstreeks contact op met de huisartsenpraktijk.
        </p>
        <button class="dvat-button dvat-button--primary" (click)="closeChat()">
          <svg width="20" height="20" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00016 0.666626L6.94183 1.60829L3.05016 5.49996H13.6668V6.83329H3.05016L6.94183 10.725L6.00016 11.6666L0.333496 5.99996L6.00016 0.666626Z" fill="currentColor"/>
          </svg>
          Terug naar de website
        </button>
      </div>
    </div>
  } @else {
  <section
    class="chat-wrapper"
    [class.chat-wrapper--is-registered]="conversationId"
    [class.chat-wrapper--is-chat-started]="messages.length > 0 || isFullSize"
    id="wrapper"
    >
    <header class="dvat-header">
        <div class="dvat-container dvat-container--fluid">
          <div>
              <div class="dvat-header__title">
                  Sparringpartner
              </div>
              <div class="dvat-header__subtitle">
                  <span>
                    Aangeboden door ahti – <a href="https://www.digitalevoordeur.amsterdam/privacyverklaring-sparringpartner" target="_blank">Lees onze privacyverklaring</a>
                  </span>
                  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.933333 8.66667L0 7.73333L6.4 1.33333H0.666667V0H8.66667V8H7.33333V2.26667L0.933333 8.66667Z" fill="white"/>
                  </svg>
              </div>
          </div>
            <div>
                <button class="dvat-header__close-btn" (click)="onCloseButtonClick()">
                    <span class="visually-hidden">Sluiten</span>
                </button>
            </div>
        </div>
    </header>

    <app-error-banner></app-error-banner>


    <div id="messages">

        <div class="dvat-container dvat-intro">
            <h3 class="dvat-intro__title">Hoe kan ik je helpen?</h3>
            <p class="dvat-intro__subtitle">
              Anoniem – zonder wachttijd
            </p>
            <p class="dvat-intro__lead">
                Stel veilig je vragen aan onze AI-assistent over gezondheid, geldzorgen, opvoeden, mentale klachten of andere dingen die je bezighouden.
            </p>
        </div>
      @if (conversationId) {
        <div class="messages-inner">
          <div class="dvat-container">
            @for (message of messages; track message.createdAt; let i = $index) {
              <div class="message"
                   [id]="'message-' + i"
                   [class.message--bot]="message.role === 'assistant'"
                   [class.message--user]="message.role === 'user'">
                @if (message.role === 'assistant') {
                  <message-bot [message]="message" [conversationId]="conversationId"></message-bot>
                }
                @if (message.role === 'user') {
                  <message-user [message]="message"></message-user>
                }
              </div>
              @if (message.role === 'assistant' && message.thuisartsArticle) {
                <thuisarts-article [article]="message.thuisartsArticle" [conversationId]="conversationId"></thuisarts-article>
              }
              @if (hasSurveyAfterMessageIndex(i)) {
                <app-survey
                  [answer]="getSurveyAnswer(i)"
                  [conversationId]="conversationId"
                  (submitted)="onSurveyAnswered(i, $event)"
                  (skipped)="onSurveySkipped(i)">
                </app-survey>
              }
            }
          </div>
          <div class="dvat-container">
            @if (isThinking) {
              <div class="thinking">
                <div class="dot-flashing"></div>
              </div>
            }
            @if (showInactivityWarning && !conversationTimedOut) {
              <app-inactivity-timer
                [countdown]="inactivityCountdown"
              ></app-inactivity-timer>
            }
            @if (conversationTimedOut) {
              <div class="dvat-timeout-message">
                <div class="dvat-timeout-message__body">
                  <h6 class="dvat-timeout-message__title">Het gesprek is beëindigd</h6>
                  <p class="dvat-timeout-message__subtitle">Er is een kwartier lang geen bericht gestuurd, daarom is het gesprek beëindigd.</p>
                  <div class="dvat-timeout-message__actions">
                    <button class="dvat-button dvat-button--primary" (click)="onStartNewConversation()">
                      Nieuw gesprek starten
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.00016 0.666626L7.05849 1.60829L10.9502 5.49996H0.333496V6.83329H10.9502L7.05849 10.725L8.00016 11.6666L13.6668 5.99996L8.00016 0.666626Z" fill="currentColor"/>
                      </svg>
                    </button>
                    <button class="dvat-button dvat-button--outline" (click)="closeChat()">
                      Gesprek sluiten
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (!conversationTimedOut) {
    <footer [class.registered]="conversationId" class="footer">
      <div class="dvat-container">
        <div class="text-input col-relative">
          <div class="input-wrap">
            <label for="inputMessage" class="visually-hidden">Bericht</label>
            <textarea
              #inputBox
              autoResize
              type="text"
              id="inputMessage"
              class="text-input"
              [disabled]="isThinking"
              [(ngModel)]="inputMessage"
              [placeholder]="messages.length > 0 ? 'Typ een bericht' : 'Bijv. Ik wil onder de mensen zijn'"
              (keydown)="onKeydown($event)"
              rows="1"
            ></textarea>
            <button
              class="dvat-send-icon"
              [class.dvat-send-icon--empty]="!inputMessage || !inputMessage.trim().length"
              [class.dvat-send-icon--busy]="isThinking"
              (click)="onSendMessage()"
            >
              <span class="visually-hidden">Verzenden</span>
            </button>
              <span class="loader" *ngIf="isThinking"></span>
          </div>
        </div>
          @if (messages.length > 0) {
              <div class="disclaimer">
                  Deze AI-assistent kan fouten maken en geeft geen medisch advies. Neem daarvoor <a href="https://kadoelerbreek.uwartsonline.nl/bereikbaarheid/" target="_blank">contact op met de huisartsenpraktijk</a>.
              </div>
          }
      </div>
    </footer>
    }
</section>
  <app-link-confirmation-modal></app-link-confirmation-modal>

  @if (showCloseModal) {
    <div class="dvat-modal-overlay" (click)="showCloseModal = false">
      <div class="dvat-modal" (click)="$event.stopPropagation()">
        <div class="dvat-modal__header">
          <h2 class="dvat-modal__title">Gesprek beëindigen?</h2>
        </div>
        <div class="dvat-modal__body">
          <p>Wanneer je het gesprek beëindigt, zal het verloren gaan.</p>
        </div>
        <div class="dvat-modal__footer">
            <button class="dvat-button dvat-button--error" (click)="onConfirmClose()">
                Gesprek beëindigen
            </button>
            <button class="dvat-button dvat-button--textual" (click)="showCloseModal = false">
                Terug naar gesprek
            </button>
        </div>
      </div>
    </div>
  }
  }
</div>
